import { configCurrentSite } from "./config";

/**
 * Build the public-site URL for the editor's current host.
 *
 * The editor and public site share the same deployment, but staging is encoded
 * in the host name (`editor.staging.example.com`). Using the canonical domain
 * returned by the API would lose that environment marker. Using the old local
 * fallback would send a staging user to localhost instead.
 */
export function getCurrentSiteUrl({
  currentHost = typeof window !== "undefined" ? window.location.host : "",
  configuredDomain = configCurrentSite.CURRENT_DOMAIN_SITE,
}: { currentHost?: string; configuredDomain?: string } = {}): string {
  const host = String(currentHost || "").trim();

  if (host && !/^localhost(?::\d+)?$/i.test(host)) {
    return `https://${host.replace(/^editor\./i, "")}`;
  }

  const domain = String(configuredDomain || host).trim();
  if (/^https?:\/\//i.test(domain)) return domain.replace(/\/$/, "");

  const localMatch = domain.match(/^localhost:(\d+)$/i);
  if (localMatch) {
    const publicPort = Math.max(1, Number(localMatch[1]) - 1);
    return `http://localhost:${publicPort}`;
  }

  return `${/^localhost$/i.test(domain) ? "http" : "https"}://${domain}`;
}
